export const uiConfig = {
  appLogo: '/yldr-logo.svg',
  mobileAppLogo: '/yldr-mobile-logo.svg',
};
